// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"8ad137fa","698":"1687e909"}[chunkId] + ".chunk.css";
};